import React, { Component } from "react";
import { Link } from "react-router-dom";

import { generalS } from "../../strings/general";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import AOS from 'aos';


import { url } from '../../inv';
import 'aos/dist/aos.css';
import "../../styles/css/about.css";
import "../../styles/css/main.css";

class AboutMain extends Component {
  constructor(props) {
    super(props);
    AOS.init({ duration: 1200 });
  }

  paragraphHandler = (p) => {
    let split = p.split("#");
    if (split.length >= 3) {
      return (
        <p>
          {`${split[0]}`}
          <a href={`${split[2]}`} target="_blank">{`${split[1]}`}</a>
          {split[3] ? split[3] : ""}
        </p>
      )
    } else {
      return split[0]
    }


  }

  render() {
    let { teamMembersObj, teamMembers,
      context, aboutUs, title, addresses, footerText } = this.props;
    let { language } = context;
    return (
      <div style={{ height: "100%" }}>
        <div className={"wrapper"}>
          <div className={"about-us-container"}>
            <div className={"home-calender-title"}>
              <span>
                {title ? title : ("")}
              </span>
            </div>
            {aboutUs && aboutUs.length > 0 ?
              <div>
                <div style={{ marginTop: 24 }}>
                  {/* <h2 className={"about-us-card-title"}>{aboutUs[0].data.value.title}</h2>
                  <h3>{aboutUs[0].data.value.subTitle}</h3><br /> */}
                  {aboutUs[0].data.value.details && aboutUs[0].data.value.details.length > 0 ?
                    aboutUs[0].data.value.details.map((p, i) => {
                      return (
                        <p>{this.paragraphHandler(p)}</p>
                      )
                    })
                    : ("")}
                </div>
                {aboutUs[0].fileNames[0] ?
                  <div className={"about-us-image-container"}>
                    <img src={`${url}/public/${aboutUs[0].fileNames[0]}`} />
                  </div> : ("")} 
              </div>
              : ("")}
          </div>
          {/* <div className={"home-calender-title"}>
            <span>
              {generalS.address[language]}
            </span>
          </div> */}
          {/* {addresses && addresses.length > 0 ?
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              {addresses.map((e, i) => {
                return (
                  <div className={"project-card-mediume"}>
                    <div style={{
                      textAlign: "center", padding: 16,
                      marginBottom: 24, border: '1px solid #ddd', borderRadius: 5
                    }}>
                      {e.data.value.title ?
                        <h3>{e.data.value.title}</h3>
                        : ("")}
                      <br />
                      {e.data.value.subTitle ?
                        <h4>{e.data.value.subTitle}</h4>
                        : ("")}
                      {e.data.value.details.length > 0 ?
                        e.data.value.details.map((d) => {
                          return (
                            <p className={"project-card-detail"}>{d}</p>
                          )
                        })

                        : ("")}
                    </div>
                  </div>
                )
              })}
            </div>
            : ("")} */}
          {/* <div className={"home-calender-title"}>
            <span>
              {generalS.ourTeam[language]}
            </span>
          </div> */}
        </div>
        <div className={"wrapper"}>
          <Footer context={context} footerText={footerText} />
        </div>
      </div>
    );
  }
}

export default AboutMain;



{/* <div className={"about-col"}>
{teamMembersObj && teamMembersObj.col2.length > 0 ?
  teamMembersObj.col2.map((a, i) => {
    return (
      <div data-aos="fade-up" className={"about-card-small"}>
        <div className={"about-card-img"}>
          <img src={`${url}/public/${a.fileNames[0]}`} />
        </div>
        <div className={"about-card-text-content-small"}>
          <div style={{
            width: "100%",
            display: "flex",
            justifyContent: "center"
          }}>
            <p className={"about-card-title"}>{a.data.value.title}</p>
          </div>
          <h3>{a.data.value.subTitle}</h3>
          <p>{a.data.value.mobile ? a.data.value.mobile : ""}</p>
          <p className={"about-card-detail"}>{a.data.value.email ? a.data.value.email : ""}</p>

          <div className={"about-card-link-content"}>
            <Link to={`/detail?${a.postId}`} className={"about-card-link"}>
              {generalS.readMore[language]}
            </Link>
          </div>
        </div>
      </div>
    )
  })
  : ("")}
</div> */}